module.exports = __webpack_public_path__ + "ptc_momoro_Q2.f767fa1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_Q2.jpg
// module id = R2Vp
// module chunks = 0